import { useTranslation } from 'react-i18next';

import { useSetActiveCompanyMutation } from '@crm/entities/company';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

import { getCompanyIdToActivate, getCompanyTargetRoute } from './companySwitch';

import type { TCompany } from '@crm/entities/company';

export const useCompanySwitch = () => {
    const { t } = useTranslation();
    const mutation = useSetActiveCompanyMutation();

    const switchCompany = (company: TCompany) => {
        const companyId = getCompanyIdToActivate(company);

        if (companyId === null) return;

        mutation.mutate(companyId, {
            onSuccess: (activeCompany) => {
                window.location.assign(getCompanyTargetRoute(activeCompany));
            },
            onError: (error) => {
                toastManager.onError({
                    title: getApiErrorMessage(
                        error,
                        t('crm.companySwitcher.errors.setActive')
                    ),
                });
            },
        });
    };

    return {
        isPending: mutation.isPending,
        switchCompany,
    };
};
